import { cn } from "@tellescope/utils";
import { RichTextEditor } from "@tellescope/ui";
import { TellescopeFormFieldBaseProps } from "../types";

export interface RichTextFieldProps extends TellescopeFormFieldBaseProps<"Rich Text"> {
  placeholder?: string;
  editable?: boolean;
}

export const RichTextField = ({
  title,
  value = "",
  onChange,
  className,
  placeholder,
  editable = true,
  error,
  onBlur,
  touched,
}: RichTextFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div className={cn("space-y-2", className)}>
      {!!title && <h4 className="text-sm font-medium">{title}</h4>}
      <RichTextEditor
        content={value}
        onChange={onChange}
        placeholder={placeholder}
        editable={editable}
        onBlur={onBlur}
        className={cn(showError && "border-destructive")}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
